import { Container, Feedback, Link, Text } from '@foradevelopment/fora-ui';

import { links } from '../../router/links';
import { useTypedTranslation } from '../../i18n/i18n';

export const EmploymentReportDeviationFeedback = () => {
  const { t } = useTypedTranslation();
  return (
    <Container marginBottom={60} maxWidth={783}>
      <Feedback type="error">
        <Text size="small" marginBottom={6}>
          {t('errorMessages.deviations')}
        </Text>
        <Link to={links.reportHistory} fontSize="small">
          {t('section.employerOverview.showAllEvents-1')}
        </Link>
      </Feedback>
    </Container>
  );
};
